import { render, staticRenderFns } from "./Davis-data.vue?vue&type=template&id=637a4c0c"
import script from "./Davis-data.vue?vue&type=script&lang=js"
export * from "./Davis-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports